<template>
  <div class="page-404">
    <div class="mt-8">
      <div class="page-404__title">404</div>
      <div class="page-404__subtitle">The page you're looking for does not exists.</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageNotFound"
};
</script>
<style scoped>
.page-404__title {
  color: #ffffff;
  font-size: 6rem;
  text-align: center;
}
.page-404__subtitle {
  color: white;
  font-size: 2rem;
  text-align: center;
}
.page-404 {
  background-color: #0087ff;
  min-height: 100vh;
}
</style>
